import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-commercial-properties',
  templateUrl: './commercial-properties.component.html',
  styleUrls: ['./commercial-properties.component.css']
})
export class CommercialPropertiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
